import React, { useState } from 'react';
import { Facebook, Instagram, Linkedin } from 'lucide-react';
import { socialLinks } from '../data/mockData';

const Newsletter = () => {
  const [newsletterSubmitted, setNewsletterSubmitted] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email')
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setNewsletterSubmitted(true);
        e.target.reset();
        setTimeout(() => setNewsletterSubmitted(false), 5000);
      } else {
        alert('Failed to sign up. Please try again.');
      }
    } catch (error) {
      console.error('Newsletter signup error:', error);
      alert('Failed to sign up. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream via-white to-cream flex items-center justify-center px-6 py-32">
      <div className="max-w-2xl w-full">
        {/* Logo */}
        <div className="text-center mb-12">
          <img
            src="/assets/MG Logo.png"
            alt="Hon Maryka Groenewald MLC"
            className="h-24 mx-auto mb-8"
          />
        </div>

        {/* Main Content Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12">
          <div className="text-center mb-8">
            <span className="text-gold text-lg md:text-xl font-bold tracking-widest uppercase">
              STAY CONNECTED
            </span>
            <h1 className="mt-4 font-cormorant text-5xl md:text-6xl text-navy italic">
              Subscribe to my Newsletter
            </h1>
            <p className="mt-6 text-lg text-gray-600 leading-relaxed">
              Get the latest on Parliament, campaigns, and my work for you as an Australian Christians MLC, 
              delivered direct to your inbox.
            </p>
          </div>

          {/* Newsletter Form */}
          <form onSubmit={handleNewsletterSubmit} className="space-y-4 mb-10">
            <input
              type="text"
              name="name"
              placeholder="YOUR NAME"
              required
              className="w-full px-6 py-4 rounded-full text-gray-900 placeholder-gray-400 border-2 border-gray-200 focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent uppercase text-sm font-medium transition-all"
            />
            <input
              type="email"
              name="email"
              placeholder="YOUR EMAIL"
              required
              className="w-full px-6 py-4 rounded-full text-gray-900 placeholder-gray-400 border-2 border-gray-200 focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent uppercase text-sm font-medium transition-all"
            />
            <button
              type="submit"
              className="bg-gold hover:bg-[#e09f0a] text-white font-bold px-12 py-4 rounded-full text-sm tracking-wide transition-all hover:shadow-lg uppercase w-full transform hover:scale-105 duration-300"
            >
              SIGN UP
            </button>
            {newsletterSubmitted && (
              <div className="text-center">
                <p className="text-gold font-bold text-lg animate-pulse">
                  ✓ Thank you for signing up!
                </p>
              </div>
            )}
          </form>

          {/* Divider */}
          <div className="relative my-10">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4 bg-white text-gray-500 font-medium">OR</span>
            </div>
          </div>

          {/* Follow My Socials */}
          <div className="text-center">
            <h2 className="font-cormorant text-3xl md:text-4xl text-navy mb-3 italic">
              Follow My Socials
            </h2>
            <p className="text-gray-600 mb-6">
              Stay up to date on social media
            </p>
            <div className="flex items-center justify-center space-x-4">
              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 rounded-full bg-gold flex items-center justify-center text-white hover:bg-[#e09f0a] transition-all hover:scale-110 duration-300 shadow-lg"
                aria-label="Facebook"
              >
                <Facebook size={24} />
              </a>
              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 rounded-full bg-gold flex items-center justify-center text-white hover:bg-[#e09f0a] transition-all hover:scale-110 duration-300 shadow-lg"
                aria-label="Instagram"
              >
                <Instagram size={24} />
              </a>
              <a
                href={socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 rounded-full bg-gold flex items-center justify-center text-white hover:bg-[#e09f0a] transition-all hover:scale-110 duration-300 shadow-lg"
                aria-label="LinkedIn"
              >
                <Linkedin size={24} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Text */}
        <div className="text-center mt-8">
          <p className="text-gray-500 text-sm">
            Fighting for life, faith, family and freedom in Western Australia
          </p>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
